import { Button } from '@mm/components';
import React from 'react';

export const FilterBarItemEditContainerButtons = ({
  className,
  onCancelEdit,
  disableDone,
  onDone,
}: {
  className: string;
  onCancelEdit: () => void;
  disableDone: boolean;
  onDone: () => void;
}) => (
  <div className={className}>
    <Button size="sm" color="secondary" onClick={onCancelEdit}>
      Cancel
    </Button>
    <Button size="sm" color="blue" onClick={onDone} disabled={disableDone}>
      Done
    </Button>
  </div>
);
